<template>
  <div>
    <v-flex xs12>
      新兆观健康 spo
    </v-flex>

    <v-data-table
      :headers="headers"
      :items="data"
      hide-actions
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <td>
          <v-list-tile-avatar>
            <img v-if="props.item.userInfoPointer.HeadPortiat" :src="props.item.userInfoPointer.HeadPortiat" alt="">
            <img v-else src="https://via.placeholder.com/50x50?text=:>" alt="">
          </v-list-tile-avatar>
        </td>
        <!-- <td><img :src="props.item.userInfoPointer.HeadPortiat" alt=""></td> -->
        <td>{{ props.item.userInfoPointer.name }}</td>
        <!-- <td>{{ props.item.objectId }}</td> -->
        <td class="text-xs-right">{{ props.item.startAt | formatStart }}</td>
        <td class="text-xs-right">{{ props.item.avgO2 }}</td>
        <td class="text-xs-right">{{ props.item.avgPr }}</td>
        <td class="text-xs-right">{{ props.item.remoteDevice }}</td>
        <td class="text-xs-right">{{ props.item.updatedAt | format }}</td>
        <!-- <td class="text-xs-right">{{ props.item.createdAt }}</td> -->
        <td class="justify-center px-0">
          <!-- <v-btn icon :href="'http://shcparse.leanapp.cn/parse/parsemhn?objId=' + props.item.objectId" target="_blank"> -->
          <!-- <v-btn icon :href="'http://localhost:3000/parse/parsemhn?objId=' + props.item.objectId" target="_blank"> -->
          <v-btn depressed icon small @click="navigateTo(props.item)">
            查看
          </v-btn>

          <v-btn depressed icon small @click="downloadBin(props.item)">
            下载
          </v-btn>
        </td>
      </template>
    </v-data-table>

    <div class="text-xs-center">
      <v-pagination
        v-model="pagination.page"
        :length="pages"
        :total-visible="7"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import { getSpoList, getSpoListCounts, fetchByObjectId } from '@/services/MhnService'
import { dateFormat, base64ToArrayBuffer, saveByteArray } from '@/utils/Util'

export default {
  data () {
    return {
      headers: [
        { text: '头像', sortable: false },
        { text: 'name', sortable: false },
        // { text: 'objectId', sortable: false },
        { text: 'startAt', sortable: false },
        { text: 'avgO2', sortable: false },
        { text: 'avgPr', sortable: false },
        { text: 'remoteDevice', sortable: false },
        // { text: 'updatedAt', align: 'center', sortable: false },
        { text: 'createdAt', sortable: false },
        { text: '', sortable: false }
      ],
      data: [],
      pagination: {
        page: 1,
        rowsPerPage: 10,
        totalItems: 0
      }
    }
  },
  methods: {
    navigateTo (item) {
      this.$router.push({path: '/parsemhn', query: {objId: item.objectId}})
    },
    async downloadBin (item) {
      const res = await fetchByObjectId(item.objectId)
      if (res.data.ringData) {
        let buffer = base64ToArrayBuffer(res.data.ringData)
        saveByteArray(item.objectId + '.bin', buffer)
      }
    }
  },
  mounted: async function () {
    getSpoListCounts().then(res => {
      this.pagination.totalItems = res.data.count
    }, err => console.error(err))
  },
  computed: {
    pages () {
      if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null
      ) return 0
      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    }
  },
  watch: {
    'pagination.page': {
      immediate: true,
      async handler (value) {
        const res = await getSpoList(10, 10 * (value - 1))
        this.data = res.data.results
      }
    }
  },
  filters: {
    format (value) {
      return dateFormat(new Date(value), 'yyyy-MM-dd hh:mm:ss')
    },
    formatStart (value) {
      return dateFormat(new Date(value * 1000), 'yyyy-MM-dd hh:mm:ss')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ListMhn.vue